import { APIScope } from "../API/APIScope.Interfaces";
import { EscalationInterface } from "../Escalations/Escalations.Interface";
import { AvailableMembersMap } from "../Members/Members.Interface";
import { NotificationBaseInterface, NotificationInterface } from "../Notifications/Notifications.Interface";
import { SessionInterface } from "../Sessions/Sessions.Interface";
import { OnlineRosterEntry } from "../User/User.Interface";

export enum SocketEventType {
  AVAILABLE_MEMBERS = "available_members",
  SESSION = "session",
  ESCALATION = "escalation",
  NOTIFICATION = "notification",
  VARS = "vars",
  USERS_ONLINE = "users_online",
  USER_UPDATED = "user_updated",

  MESSAGE = "msg",

  // Metadata events:
  META_ROOM_STATE_REQUEST = "meta_room_state_request",
}

export type SubscribableSocketEventType =
  | SocketEventType.AVAILABLE_MEMBERS
  | SocketEventType.SESSION
  | SocketEventType.ESCALATION
  | SocketEventType.NOTIFICATION
  | SocketEventType.VARS
  | SocketEventType.USERS_ONLINE;
// | SocketEventType.NOTIFICATIONS // We always stay subscribed to notifications

export interface RoomStateRequestData {
  subscriptions: {
    [SocketEventType.VARS]?: { userId: number }; // Note this uses userId instead of orgId
    [SocketEventType.NOTIFICATION]?: { memberId: number }; // Note this uses memberId instead of orgId
    [SocketEventType.AVAILABLE_MEMBERS]?: { orgId: number }; // Note this uses memberId instead of orgId
    [SocketEventType.SESSION]?: { orgId: number };
    [SocketEventType.USERS_ONLINE]?: { orgId: number };
    [SocketEventType.ESCALATION]?: { orgId: number };
  };
  jwt: string;
  orgId: number;
}

export const SubscriptionKey = {
  forAvailableMembers: (orgId: number) => `${SocketEventType.AVAILABLE_MEMBERS}:${orgId}`,
  forSessions: (orgId: number) => `${SocketEventType.SESSION}:${orgId}`,
  forEscalations: (orgId: number) => `${SocketEventType.ESCALATION}:${orgId}`,
  // Uses userId/memberId instead of orgId:
  forVars: (memberId: number) => `${SocketEventType.VARS}:${memberId}`,
  forNotifications: (userId: number) => `${SocketEventType.NOTIFICATION}:${userId}`,
  forUserUpdated: (orgId: number) => `${SocketEventType.USER_UPDATED}:${orgId}`,
  forUsersOnline: (orgId: number) => `${SocketEventType.USERS_ONLINE}:${orgId}`,
  // Only used by calls to Conversations.Manager.ts:
  // forConversationItems: (orgId: number) => `${SocketEventType.CONVERSATION_ITEMS}:${orgId}`,
  // forConversationActivity: (orgId: number) => `${SocketEventType.CONVERSATION_ACTIVITY}:${orgId}`,
  // Only used by WebSocket.Channel.ts / MessageRouter.ts:
  forMessage: (userId: number) => `${SocketEventType.MESSAGE}:${userId}`, // Note use of userId
};

export const SocketEventRequiredAPIScope = {
  [SocketEventType.AVAILABLE_MEMBERS]: APIScope.CONVERSATION_VIEW,
  [SocketEventType.SESSION]: APIScope.CONVERSATION_VIEW,
  [SocketEventType.ESCALATION]: APIScope.CONVERSATION_VIEW,
  [SocketEventType.VARS]: APIScope.CONVERSATION_VIEW,
  [SocketEventType.NOTIFICATION]: APIScope.CONVERSATION_VIEW,
  [SocketEventType.USERS_ONLINE]: APIScope.CONVERSATION_VIEW,

  // [SocketEventType.CONVERSATION_ITEMS]: APIScope.CONVERSATION_VIEW,
  // [SocketEventType.CONVERSATION_ACTIVITY]: APIScope.CONVERSATION_VIEW,
  [SocketEventType.MESSAGE]: APIScope.CONVERSATION_VIEW,
};

export interface SocketEventAvailableMembersUpdated {
  type: SocketEventType.AVAILABLE_MEMBERS;
  orgId: number;
  payload: AvailableMembersMap;
}
export interface SocketEventUpdateSession {
  type: SocketEventType.SESSION;
  orgId: number;
  payload: SessionInterface;
}
export interface SocketEventUpdateEscalation {
  type: SocketEventType.ESCALATION;
  orgId: number;
  payload: EscalationInterface;
}

export interface SocketEventUpdateUsersOnline {
  type: SocketEventType.USERS_ONLINE;
  orgId: number;
  payload: { [userId: number]: OnlineRosterEntry };
}
export interface SocketEventUpdateVars {
  type: SocketEventType.VARS;
  userId: number; // Note userId instead of orgId
  payload: { [key: string]: string | undefined }; // AdamTodo any?
}

export interface SocketEventUserUpdated {
  type: SocketEventType.USER_UPDATED;
  orgId: number;
  userId: number;
  payload: { [key: string]: string | undefined }; // AdamTodo any?
}
export interface SocketEventNotification {
  type: SocketEventType.NOTIFICATION;
  memberId: number; // Note MEMBER id
  payload: NotificationInterface; // AdamTodo is this EscalationNotificationInterface[]?
}
